// extracted by mini-css-extract-plugin
module.exports =  {"select":"UserModal__select","calendar":"UserModal__calendar"};